import { useEffect } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import { useRouter } from 'next/router';
import { useCountDown } from 'ahooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { endTime } from '@/data/ecocreditsday';
import gtm from '@/utils/gtm';
import { MUTI_AREA_ARR } from '@/componentsH5/EcoCreditsDay/components/AnchorTabs/constant';

const timelineName = styles.timeline;
export default function TimeLineComp() {
    const { t } = useLang('ecocreditsday.timeLine');
    const { locale } = useRouter();
    const { getSystemTime } = useGlobal();
    const start = getSystemTime();
    const end = endTime[locale as keyof typeof locale] || endTime.kr;
    const [countdown] = useCountDown({ leftTime: end - start });

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `.${timelineName}`,
            offset: 200, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 300,
        });
        const timeline = new TimelineMax();

        const tweenA1 = TweenMax.to(`.${timelineName} .title`, 0.5, { opacity: 0.9 });

        const tweenA2 = TweenMax.to(`.${timelineName} .timeline-box`, 0.5, { opacity: 1, rotateX: 0 });
        timeline.add(tweenA1).add(tweenA2, 0.1);

        scene.setTween(timeline);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    // const renderTitle = (text: string) => {
    //     if (['au'].includes(locale)) {
    //         return (
    //             <>
    //                 <br />
    //                 <span className="red-color">{text}</span>
    //             </>
    //         );
    //     }

    //     return <span className="red-color">{text}</span>;
    // };

    return (
        <div className={`${timelineName} timeline`}>
            {MUTI_AREA_ARR.includes(locale as string) && (
                <div className="title">{t.rich('title', { line1: (text: any) => <span className="red-color">{text}</span> })}</div>
            )}
            <div className="timeline-box">
                <div className="line"></div>
                <div className="text-box">
                    <div className="date-text">{t('date1')}</div>
                    <div className="date-desc">{t('date1_desc')}</div>
                    {['kr'].includes(locale as string) && (
                        <div className="date-tip">{t.rich('date1_tip', { line1: (text: string) => <span>{text}</span> })}</div>
                    )}
                    <div className="date-text">{t('date2')}</div>
                    <div className="date-desc">{t('date2_desc')}</div>
                    {['kr', 'us', 'ca'].includes(locale as string) && <div className="date-tip">{t('date2_tip')}</div>}
                </div>
            </div>
            {!['jp'].includes(locale as string) && countdown !== 0 && (
                <div
                    className="sale-text"
                    onClick={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'ecocredits_button',
                            type: 'Other',
                            list_name: 'Introduction',
                            button_name: t('sale_btn'),
                        });
                        const linkMap = {
                            za: `https://${locale}.ecoflow.com/pages/ecocredits-day-sale`,
                            au: 'https://au.ecoflow.com',
                        };
                        const link = linkMap[locale as keyof typeof linkMap] || linkMap.za;
                        window.open(link);
                    }}
                >
                    {t('sale_btn')}
                </div>
            )}
        </div>
    );
}
